import axios from 'axios';
import { Navigate, useNavigate } from "react-router-dom";
import { Alert, AlertColor, Button, LinearProgress, Paper, Snackbar, TextField } from "@mui/material";
import { authData, isLoggedIn, setAuthData } from "../services/AuthService";
import MusashiHome from "../images/MusashiHome.png";
import MusashiJapan from "../images/MusashiJapan.png";
import React from 'react';

const styles = {
    translucentBackground: {
        backgroundImage: `url(${MusashiHome})`,
        width: '100vw',
        height: '100vh',
        backgroundPosition: 'left',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    },

    content: {
      height: '100%',
      width: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    }
};

export function LoginPage() {
    const navigate = useNavigate();
    const [snackOpen, setSnackOpen] = React.useState<boolean>(false);
    const [snackMessage, setSnackMessage] = React.useState<string>("");
    const [snackSubMessage, setSnackSubMessage] = React.useState<string>("");
    const [snackSeverity, setSnackSeverity] = React.useState<AlertColor | undefined>(undefined);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [userName, setUserName] = React.useState<string>("");
    const [password, setPassword] = React.useState<string>("");
    const [rememberMe, setRememberMe] = React.useState<boolean>(false);

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        
        var bodyFormData = new FormData();
        if (userName=="" || password=="")
            return false;

        bodyFormData.append("username", event.currentTarget.username.value);
        bodyFormData.append("password", event.currentTarget.password.value);

        setLoading(true);

        if (isLoggedIn())
            navigate("/app");

        axios.post<authData>('Api/V1/Auth/Login', bodyFormData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(function (response) {
                if (response.data)
                {
                    setAuthData(response.data, rememberMe);
                    setLoading(false);
                    navigate("/app");
                }
                else
                {
                    setUserName("");
                    setPassword("");
                    showSnackBar("Login failed", "", "error");
                    setLoading(false);
                }
            })
            .catch((error) => {
				console.log(error);
				showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
                setLoading(false);
			});
    }

    function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
        setSnackMessage(message);
        setSnackSubMessage(subMessage);
        setSnackSeverity(colour);
        setSnackOpen(Boolean(message));
    }

    return (
        <div>
            <div style={styles.translucentBackground}>
                <div style={styles.content}>
                    <div style={{ position: 'absolute', left: '50%', top: '50%', WebkitTransform: "Translate(-50%, -50%)", transform: "transform(-50%, -50%)"}}>
                        <Paper variant="outlined">
                            <div style={{ paddingBottom: '1vh'}} >
                                <img src={MusashiJapan} alt="MusashiJapan" />
                            </div>
                            <form noValidate autoComplete="off" onSubmit={(e) => handleSubmit(e)}>
                                <div style={{ justifyContent: 'center', alignItems: 'center',  display: "flex", paddingBottom: '1vh'}}>
                                    <TextField id="username" label="User Name" style={{ display: 'flex', width: '90%' }} value={userName} onChange={(e) => setUserName(e.target.value)} />
                                </div>
                                <div style={{ justifyContent: 'center', alignItems: 'center',  display: "flex", paddingBottom: '1vh'}}>
                                    <TextField id="password" label="Password" type="password" style={{ display: 'flex', width: '90%' }} 
                                    value={password} onChange={(e) => setPassword(e.target.value)} />
                                </div>
                                <div style={{ justifyContent: 'center', alignItems: 'center',  display: "flex", paddingBottom: '1vh'}}>
                                    <Button variant="contained" color="secondary" type='submit' style={{ display: 'flex', width: '80%', paddingTop: '1vh', paddingBottom: '1vh'}} >
                                            Login
                                    </Button>
                                </div>
                            </form>

                            <div hidden={!loading}>
                                <LinearProgress />
                            </div>
                        </Paper>
                    </div>
                </div>

                <Snackbar open={snackOpen} autoHideDuration={18000} onClose={() => setSnackOpen(false)}
                    anchorOrigin={{ horizontal: "center", vertical: "bottom" }}>
                    <Alert onClose={() => setSnackOpen(false)} severity={snackSeverity}>
                        {snackMessage}
                        {snackSubMessage !== undefined || snackSubMessage !== null ? (<br />) : (<div></div>)}
                        {snackSubMessage}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    )
}

export default LoginPage